import { PrepareApiProcedure } from '../components/common/utils/prepare-api-procedure';
import {
  ActiveChargeStatus,
  ChargerAttributes,
  ChargerManufacturerInfo,
} from '../models/charger-model';
import { OrderAttributes } from '../models/order-model';
import {
  ChargerSchedule,
  SendSchedule,
  setSchedule,
} from '../store/actions/scheduling-actions';
import {
  ApiRequest,
  ApiResponse,
  fetchDataFromAPI,
  fetchDataFromAPITyped,
} from './api-requests';

export const checkinCharger = async (
  orderId: string
): Promise<ApiResponse<null | undefined>> => {
  //check in the charger
  const apiQuery: ApiRequest = {
    route: 'charger/checkin',
    request: {
      method: 'POST',
      entity: 'charger',
      body: {
        orderId: orderId,
      },
    },
  };
  return fetchDataFromAPITyped(apiQuery);
};

export const checkoutCharger = async (
  orderId: string,
  email: string,
  scheduleId?: string | null
) => {
  //Check out the charger using the checkout API
  const d = new Date().getTimezoneOffset();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const apiQuery: ApiRequest = {
    route: 'charger/checkout',
    request: {
      method: 'POST',
      entity: 'charger',
      body: {
        orderId: orderId,
        tz_offset: d,
        tz: tz,
        email: email,
        scheduleId: scheduleId ?? null,
      },
    },
  };

  return await fetchDataFromAPITyped<null>(apiQuery);
  // TODO: Check the response for success here
};

export const getActiveChargeData = async (orderId: string) => {
  const apiRequest: ApiRequest = {
    route: 'charger/getActiveChargeData',
    request: {
      method: 'POST',
      entity: 'charger',
      body: { orderId: orderId },
    },
  };
  return fetchDataFromAPITyped<ActiveChargeStatus>(apiRequest);
};

export const getUserActiveCharges = async () => {
  const apiRequest: ApiRequest = {
    route: 'user/getActiveCharges',
    request: {
      method: 'GET',
      entity: 'user',
      body: undefined,
    },
  };
  return fetchDataFromAPITyped<any[]>(apiRequest);
};

export const getManufacturerInfoForCharger = async (
  serialNumber: string,
  manufacturer: string
) => {
  const apiRequest: ApiRequest = {
    route: `charger/${serialNumber}/manufacturerInfo/${manufacturer}`,
    request: {
      method: 'GET',
      entity: 'charger',
      body: undefined,
    },
  };
  const manufacturerInfo =
    fetchDataFromAPITyped<ChargerManufacturerInfo>(apiRequest);
  return manufacturerInfo;
};

export const getSingleChargerData = async (chargerId: string) => {
  try {
    const apiQuery = PrepareApiProcedure(
      `charger/getSingleCharger`,
      'POST',
      'charger',
      {
        chargerId: chargerId,
      }
    );
    const singleCharger = await fetchDataFromAPI(apiQuery);
    return singleCharger[0];
  } catch (error) {
    console.log(error);
  }
};

export const listMyChargers = async () => {
  try {
    const apiRequest: ApiRequest = {
      route: `charger/getMyChargers`,
      request: {
        method: 'GET',
        entity: 'charger',
        body: undefined,
      },
    };
    const myChargers = fetchDataFromAPITyped<ChargerAttributes[]>(apiRequest);
    return myChargers;
  } catch (error) {
    return null;
  }
};

export const getLastUsedCharger = async () => {
  try {
    const apiRequest: ApiRequest = {
      route: 'charger/getLastUsedCharger',
      request: {
        method: 'GET',
        entity: 'charger',
        body: undefined,
      },
    };
    return fetchDataFromAPITyped<ChargerAttributes>(apiRequest);
  } catch (error) {
    return null;
  }
};

interface ActiveOrderStatus_t {
  message: string;
  orders: OrderAttributes[];
}

export const getActiveOrdersByChargerId = async (chargerId: string) => {
  const apiRequest: ApiRequest = {
    route: `charger/status/activeorders/${chargerId}`,
    request: {
      method: 'GET',
      entity: 'charger',
      body: undefined,
    },
  };
  return fetchDataFromAPITyped<ActiveOrderStatus_t>(apiRequest);
};